import moment from 'moment';
import { getDaysPerMonth } from '../utils/date';

export const getMonthOptions = (locale) => [
  {
    label: locale.get('schedulerReact.jan'),
    value: '1'
  },
  {
    label: locale.get('schedulerReact.feb'),
    value: '2'
  },
  {
    label: locale.get('schedulerReact.mar'),
    value: '3'
  },
  {
    label: locale.get('schedulerReact.apr'),
    value: '4'
  },
  {
    label: locale.get('schedulerReact.may'),
    value: '5'
  },
  {
    label: locale.get('schedulerReact.jun'),
    value: '6'
  },
  {
    label: locale.get('schedulerReact.jul'),
    value: '7'
  },
  {
    label: locale.get('schedulerReact.aug'),
    value: '8'
  },
  {
    label: locale.get('schedulerReact.sep'),
    value: '9'
  },
  {
    label: locale.get('schedulerReact.oct'),
    value: '10'
  },
  {
    label: locale.get('schedulerReact.nov'),
    value: '11'
  },
  {
    label: locale.get('schedulerReact.dec'),
    value: '12'
  }
];

export const getDaysOptionsForMonth = (month) => (
  Array(getDaysPerMonth(month)).fill().map((_, idx) => ({
    label: moment(`2019-10-${idx + 1 >= 10 ? idx + 1 : `0${idx + 1}`}`).format('Do'),
    value: (idx + 1).toString()
  }))
);
